<template>
  <v-navigation-drawer v-model="openDrawer" :width="250" app right class="mobile-drawer"
                       v-click-outside="() => !openDrawer && $emit('close')">
    <v-col class="d-flex flex-column justify-space-between" style="height: 100dvh">
      <v-row>
        <v-col>
          <v-list dense nav>
            <v-list-item>
              <div class="d-flex align-center">
                <v-icon class="mr-3" color="primary">mdi-account-outline</v-icon>
                <span>{{ userFullName }}</span>
              </div>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-group :value="false" class="mt-4">
              <template v-slot:activator>
                <v-list-item class="pa-0 ma-0">
                  <v-list-item-avatar :size="20">
                    <img :alt="locale.text" :src="getFlagSrc(`${locale}.svg`)"/>
                  </v-list-item-avatar>
                  <v-list-item-title>{{ localeText }}</v-list-item-title>
                </v-list-item>
              </template>

              <v-list-item v-for="l in locales" :key="l.value"
                           link :class="{ 'primary white--text' : locale === l.value }"
                           @click.prevent="setLanguageSelected(idUser, l.value), $emit('close')">
                <v-list-item-avatar :size="20">
                  <img :alt="l.text" :src="getFlagSrc(l.flag)"/>
                </v-list-item-avatar>
                <v-list-item-title>{{ l.text }}</v-list-item-title>
              </v-list-item>
            </v-list-group>

            <v-list-group :value="false" class="mt-4">
              <template v-slot:activator>
                <v-list-item class="pa-0 ma-0">
                  <v-list-item-avatar :size="20" rounded>
                    <v-icon class="mr-1" color="primary">mdi-briefcase-variant-outline</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-title>{{ companySelected.companyDescr }}</v-list-item-title>
                </v-list-item>
              </template>

              <v-list-item v-for="c in companies" :key="c.idCompany"
                           link :class="{ 'primary white--text' : companySelected.idCompany === c.idCompany }"
                           @click.prevent="updateCompanySelected(c)">
                <v-list-item-title>{{ c.companyDescr }}</v-list-item-title>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-col>
      </v-row>

      <div class="d-flex justify-center">
        <v-btn block @click.prevent="logout">
          <v-icon class="mr-2">mdi-logout</v-icon>
          {{ $t('common.logout') }}
        </v-btn>
      </div>
    </v-col>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MobileDrawer',

  props: {
    drawer: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      openDrawer: false
    };
  },

  computed: {
    ...mapGetters({
      idUser: 'auth/idUser',
      userFullName: 'auth/userFullName',
      companies: 'auth/companies',
      companySelected: 'auth/companySelected',
      locale: 'locale/locale',
      locales: 'locale/locales'
    }),

    localeText() {
      return this.locales.find(l => l.value === this.locale).text;
    }
  },

  watch: {
    drawer(newVal) {
      this.openDrawer = newVal;
    }
  },

  methods: {
    ...mapActions({
      setLanguageSelected: 'auth/setLanguageSelected',
      setCompanySelected: 'auth/setCompanySelected'
    }),

    getFlagSrc(flagFileName) {
      return require(`@/assets/locale/${ flagFileName }`);
    },

    async logout() {
      this.$emit('close');
      await this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },

    updateLanguageSelected(locale) {
      this.setLanguageSelected({ idUser: this.idUser, locale }).then(() => {
        window.location.reload();
      }).catch((e) => {
        console.error(e);
      });
    },
    updateCompanySelected(company) {
      this.setCompanySelected( { idUser: this.idUser, idCompany: company.idCompany }).then(() => {
        this.$emit('close');
        window.location.reload();
      }).catch((e) => {
        console.error(e);
      });
    }
  }
};
</script>

<style>
.mobile-drawer {
  z-index: 4;
}
</style>
